import { Grid, SearchTextField } from "designSystem/index";
import React from "react";

export default () => (
	<Grid container spacing={5}>
		<Grid
			container
			item
			spacing={8}
			xs={12}
		>
			<Grid item>
				<SearchTextField
					hideClearButton
					label="Empty Filter field"
					placeholder="Type keyword to filter"
					selectOnFocus
				/>
			</Grid>
			<Grid item>
				<SearchTextField
					disabled
					hideClearButton
					label="Disabled Filter field"
					placeholder="Type keyword to filter"
					selectOnFocus
				/>
			</Grid>
			<Grid item>
				<SearchTextField
					defaultValue="Input"
					hideClearButton
					label="Filter field"
					placeholder="Type keyword to filter"
					selectOnFocus
				/>
			</Grid>
		</Grid>
	</Grid>
);